/* Hortelã 2.0 · botão "Filtrar" da coleção: lista de cores e a cor escolhida (?cor=azul-bebe).
   A Shopify guarda a página da coleção pronta sem olhar o ?cor=, então a cor é aplicada aqui no navegador:
   a grade de todas as peças vem de sections/h2-grade-cor.liquid e aqui ficam só as que têm a cor à venda,
   já com a foto dessa cor. */
(function () {
  if (window.h2ColecaoCor) return;
  window.h2ColecaoCor = true;

  var raiz = document.documentElement;
  var modoCor = false;

  function dados() {
    var el = document.getElementById('h2-cores-dados');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // "Azul Bebê" ou "azul%20bebe" → "azul-bebe"
  function chave(texto) {
    return String(texto || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function lerMapa(d) {
    var cores = {};
    String(d.mapa || '').split(';').forEach(function (parte) {
      var c = parte.split('=');
      if (c.length >= 3 && c[0].trim()) cores[c[0].trim()] = { nome: c[1], hex: c[2] };
    });
    var apelidos = {};
    String(d.apelidos || '').split('|').forEach(function (parte) {
      var c = parte.split('>');
      if (c.length === 2 && c[0].trim()) apelidos[c[0].trim()] = c[1].trim();
    });
    return { cores: cores, apelidos: apelidos };
  }

  function corDaUrl(mapa) {
    var valor = new URLSearchParams(location.search).get('cor');
    if (!valor) return null;
    var k = chave(valor);
    if (mapa.apelidos[k]) k = mapa.apelidos[k];
    return mapa.cores[k] ? k : null;
  }

  // endereço desta página sem a cor (fica a ordem escolhida)
  function semCor() {
    var u = new URL(location.href);
    u.searchParams.delete('cor');
    u.searchParams.delete('page');
    return u.pathname + u.search;
  }

  function bola(hex) {
    var s = document.createElement('span');
    s.className = 'h2-cor__bola' + (hex === 'colorido' ? ' h2-cor__bola--colorido' : '');
    if (hex !== 'colorido') s.style.setProperty('--cor', hex);
    return s;
  }

  function textoQtd(n, nome) {
    if (n === 0) return 'nenhuma peça em ' + nome;
    if (n === 1) return '1 peça em ' + nome;
    return n + ' peças em ' + nome;
  }

  // etiqueta da cor ao lado do Filtrar, e a cor marcada dentro do menu
  function marcarBarra(k, cor) {
    var barra = document.querySelector('.toolbar-products');
    if (!barra || barra.hasAttribute('data-h2-cor')) return;
    barra.setAttribute('data-h2-cor', k);
    barra.classList.add('h2-toolbar--cor');
    var limpar = semCor();

    var pilula = document.createElement('a');
    pilula.className = 'h2-cor-pilula';
    pilula.href = limpar;
    pilula.setAttribute('aria-label', 'Tirar a cor ' + cor.nome);
    pilula.appendChild(bola(cor.hex));
    var nome = document.createElement('span');
    nome.textContent = cor.nome;
    pilula.appendChild(nome);
    pilula.insertAdjacentHTML('beforeend', '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>');
    var botaoFiltrar = barra.querySelector('.toolbar-sorter');
    if (botaoFiltrar) botaoFiltrar.insertAdjacentElement('afterend', pilula); else barra.appendChild(pilula);

    var caixa = barra.querySelector('.h2-ordem-cores');
    if (!caixa) return;
    caixa.classList.add('is-aberto');
    var botao = caixa.querySelector('[data-h2-ordem-cores]');
    if (botao) {
      botao.setAttribute('aria-expanded', 'true');
      var atual = document.createElement('span');
      atual.className = 'h2-ordem-cores__atual';
      atual.appendChild(bola(cor.hex));
      atual.appendChild(document.createTextNode(cor.nome));
      botao.insertBefore(atual, botao.querySelector('.h2-ordem-cores__seta'));
    }
    marcarLista(caixa, k, limpar);
  }

  function marcarLista(caixa, k, limpar) {
    var lista = caixa.querySelector('.h2-ordem-cores__lista');
    if (!lista || lista.querySelector('.h2-ordem-cor--todas')) return;
    var todas = document.createElement('a');
    todas.className = 'h2-ordem-cor h2-ordem-cor--todas';
    todas.href = limpar;
    todas.textContent = 'Todas as cores';
    lista.insertBefore(todas, lista.firstChild);
    var item = lista.querySelector('.h2-ordem-cor[data-h2-cor="' + k + '"]');
    if (item) {
      item.classList.add('is-atual');
      item.setAttribute('aria-current', 'true');
    }
  }

  // título com o total da cor; as categorias levam a cor junto
  function marcarTopo(k, cor, n) {
    var topo = document.querySelector('.h2-ctopo[data-h2-filtro-cor]');
    if (!topo) return;
    var qtd = topo.querySelector('.h2-ctopo__qtd');
    if (qtd) {
      qtd.textContent = textoQtd(n, cor.nome);
      qtd.style.visibility = '';
    }
    topo.querySelectorAll('.h2-ctopo__chip').forEach(function (a) {
      var u = new URL(a.getAttribute('href'), location.origin);
      u.searchParams.set('cor', k);
      a.setAttribute('href', u.pathname + u.search);
    });
  }

  function desfazerTopo() {
    var topo = document.querySelector('.h2-ctopo[data-h2-filtro-cor]');
    if (!topo) return;
    topo.querySelectorAll('.h2-ctopo__qtd, .h2-ctopo__texto').forEach(function (el) {
      el.style.visibility = '';
      el.style.display = '';
    });
  }

  // se a grade da cor não der certo: tira a etiqueta e as marcas da cor
  function desfazerBarra() {
    var barra = document.querySelector('.toolbar-products');
    if (!barra) return;
    barra.removeAttribute('data-h2-cor');
    barra.classList.remove('h2-toolbar--cor');
    barra.querySelectorAll('.h2-cor-pilula, .h2-ordem-cores__atual, .h2-ordem-cor--todas').forEach(function (el) { el.remove(); });
    barra.querySelectorAll('.h2-ordem-cor.is-atual').forEach(function (el) {
      el.classList.remove('is-atual');
      el.removeAttribute('aria-current');
    });
  }

  function avisoCarregando(cor) {
    var grade = document.getElementById('product-grid');
    if (!grade || document.querySelector('.h2-cor-carregando')) return;
    var aviso = document.createElement('p');
    aviso.className = 'h2-cor-carregando';
    aviso.setAttribute('role', 'status');
    aviso.textContent = 'Buscando as peças em ' + cor.nome + '…';
    grade.parentNode.insertBefore(aviso, grade);
  }

  function tirarAviso() {
    var aviso = document.querySelector('.h2-cor-carregando');
    if (aviso) aviso.remove();
  }

  // "azul-bebe=Azul Bebê|branco=Branco|" → valor de uma cor
  function parDa(item, atributo, k) {
    var partes = (item.getAttribute(atributo) || '').split('|');
    for (var i = 0; i < partes.length; i++) {
      var pos = partes[i].indexOf('=');
      if (pos > 0 && partes[i].slice(0, pos) === k) return partes[i].slice(pos + 1);
    }
    return '';
  }

  function vazio(k, cor, d) {
    var caixa = document.createElement('div');
    caixa.className = 'h2-cor-vazio h2';
    caixa.id = 'product-grid';
    var titulo = document.createElement('p');
    titulo.className = 'h2-cor-vazio__titulo';
    titulo.textContent = 'Nesta coleção ainda não tem peça em ' + cor.nome + '.';
    caixa.appendChild(titulo);
    var naTodas = d.todos && location.pathname.replace(/\/$/, '') === d.todos;
    var texto = document.createElement('p');
    texto.className = 'h2-cor-vazio__texto';
    texto.textContent = naTodas ? 'Escolha outra cor no "Filtrar".' : 'Escolha outra cor no "Filtrar" ou veja tudo o que a loja tem nessa cor.';
    caixa.appendChild(texto);
    if (!naTodas && d.todos) {
      var link = document.createElement('a');
      link.className = 'h2-btn h2-btn--escuro';
      link.href = d.todos + '?cor=' + encodeURIComponent(k);
      link.textContent = 'Ver tudo em ' + cor.nome;
      caixa.appendChild(link);
    }
    return caixa;
  }

  var POR_PAGINA = 50; // igual ao paginate de sections/h2-grade-cor.liquid

  function buscarPagina(base, pagina, sinal) {
    var u = new URL(base, location.origin);
    if (pagina > 1) u.searchParams.set('page', pagina);
    return fetch(u.pathname + u.search, { credentials: 'same-origin', signal: sinal })
      .then(function (r) {
        if (!r.ok) throw new Error('grade ' + r.status);
        return r.text();
      })
      .then(function (texto) {
        var doc = new DOMParser().parseFromString(texto, 'text/html');
        if (!doc.querySelector('.h2-grade-cor')) throw new Error('grade vazia');
        return Array.prototype.slice.call(doc.querySelectorAll('[data-h2-cores]'));
      });
  }

  // as bolinhas dos cards só respondem depois que o tema define <variant-radios>
  function esperarCards() {
    if (!window.customElements || customElements.get('variant-radios')) return Promise.resolve();
    return Promise.race([
      customElements.whenDefined('variant-radios'),
      new Promise(function (ok) { setTimeout(ok, 3000); })
    ]);
  }

  // a peça na cor escolhida: bolinha, foto e preço dessa cor, e os links já abrem nessa variação
  function naCor(item, k) {
    var valor = parDa(item, 'data-h2-valores', k);
    if (valor) {
      var bolinhas = item.querySelectorAll('.product__color-swatches--js');
      for (var i = 0; i < bolinhas.length; i++) {
        if (bolinhas[i].getAttribute('data-value') === valor) {
          if (!bolinhas[i].classList.contains('active')) bolinhas[i].click();
          break;
        }
      }
    }
    var id = parDa(item, 'data-h2-variantes', k);
    if (!id) return;
    item.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var u = new URL(a.getAttribute('href'), location.origin);
      u.searchParams.set('variant', id);
      a.setAttribute('href', u.pathname + u.search);
    });
    item.querySelectorAll('[data-url*="product-quickview"]').forEach(function (el) {
      var u = new URL(el.getAttribute('data-url'), location.origin);
      u.searchParams.set('variant', id);
      el.setAttribute('data-url', u.pathname + u.search);
    });
  }

  function mostrar(itens, k, cor, d) {
    var grade = document.getElementById('product-grid');
    if (!grade) throw new Error('sem grade');
    if (!itens.length) {
      grade.replaceWith(vazio(k, cor, d));
      return 0;
    }
    grade.classList.remove('loadmore-lists');
    grade.innerHTML = itens.map(function (el) { return el.outerHTML; }).join('');
    grade.querySelectorAll('[data-h2-cores]').forEach(function (item) { naCor(item, k); });
    return itens.length;
  }

  // troca a grade da coleção pelas peças da cor escolhida (as páginas da grade vêm ao mesmo tempo)
  function montarGrade(k, cor, d) {
    var base = new URL(d.grade, location.origin);
    var ordem = new URLSearchParams(location.search).get('sort_by');
    if (ordem) base.searchParams.set('sort_by', ordem);
    var paginas = Math.max(1, Math.ceil((parseInt(d.total, 10) || 0) / POR_PAGINA));
    var controle = window.AbortController ? new AbortController() : null;
    var limite = setTimeout(function () { if (controle) controle.abort(); }, 15000);
    var pedidos = [];
    for (var p = 1; p <= paginas; p++) pedidos.push(buscarPagina(base.href, p, controle ? controle.signal : undefined));
    return Promise.all(pedidos)
      .then(function (listas) {
        clearTimeout(limite);
        var marca = ',' + k + ',';
        var vistos = {};
        var itens = [].concat.apply([], listas).filter(function (el) {
          var id = el.getAttribute('data-h2-produto');
          if (id && vistos[id]) return false;
          if (id) vistos[id] = true;
          return el.getAttribute('data-h2-cores').indexOf(marca) !== -1;
        });
        return esperarCards().then(function () { return mostrar(itens, k, cor, d); });
      }, function (erro) {
        clearTimeout(limite);
        throw erro;
      });
  }

  function iniciar() {
    var d = dados();
    if (!d) return;
    var mapa = lerMapa(d);
    var k = corDaUrl(mapa);
    if (!k) {
      raiz.classList.remove('h2-modo-cor');
      desfazerTopo();
      return;
    }
    modoCor = true;
    raiz.classList.add('h2-modo-cor');
    var cor = mapa.cores[k];
    marcarBarra(k, cor);
    avisoCarregando(cor);
    montarGrade(k, cor, d)
      .then(function (n) {
        tirarAviso();
        marcarTopo(k, cor, n);
        raiz.classList.add('h2-cor-pronto');
      })
      .catch(function () {
        // não deu para montar a grade da cor: fica a coleção inteira, sem a etiqueta da cor
        modoCor = false;
        tirarAviso();
        desfazerBarra();
        raiz.classList.remove('h2-modo-cor');
        raiz.classList.add('h2-cor-pronto');
        desfazerTopo();
      });
  }

  // abre e fecha a lista de cores dentro do Filtrar (vale também depois que a grade recarrega)
  document.addEventListener('click', function (e) {
    var botao = e.target.closest ? e.target.closest('[data-h2-ordem-cores]') : null;
    if (!botao) return;
    e.preventDefault();
    e.stopPropagation();
    var caixa = botao.parentNode;
    var aberto = caixa.classList.toggle('is-aberto');
    botao.setAttribute('aria-expanded', aberto ? 'true' : 'false');
    // da página 2 em diante: busca a lista de cores da página 1
    var url = caixa.getAttribute('data-h2-cores-url');
    if (!aberto || !url || caixa.hasAttribute('data-h2-carregou')) return;
    caixa.setAttribute('data-h2-carregou', '');
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var nova = new DOMParser().parseFromString(html, 'text/html').querySelector('.h2-ordem-cores__lista');
        var lista = caixa.querySelector('.h2-ordem-cores__lista');
        if (nova && lista) lista.innerHTML = nova.innerHTML;
      })
      .catch(function () { caixa.removeAttribute('data-h2-carregou'); });
  });

  // com uma cor escolhida, mudar a ordem recarrega a página mantendo a cor
  document.addEventListener('click', function (e) {
    if (!modoCor) return;
    var item = e.target.closest ? e.target.closest('.h2-ordem filter-sort') : null;
    if (!item) return;
    e.preventDefault();
    e.stopPropagation();
    var u = new URL(location.href);
    u.searchParams.delete('page');
    u.searchParams.set('sort_by', item.getAttribute('value'));
    location.href = u.pathname + u.search;
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
